import { EmployeeScheduleCalendar } from '../../Components/EmployeeScheduleCalendar';
import { type ReactElement } from 'react';

export const TimeGridCard = (): ReactElement => {
  return <EmployeeScheduleCalendar allowMonthSwitching={false} />;
};
